import React, { Component } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";

class Testimoni extends Component {
  render() {
    return (
      <section className="pb-16">
        <h2 className="text-heading-color text-4xl pt-11 font-bold text-center mb-12">
          OUR HAPPY CUSTOMER
        </h2>
        <Splide
          options={{
            rewind: true,
          }}
        >
          <SplideSlide>
            <div className="flex justify-center lg:mt-20">
              <div className="card flex flex-col lg:flex-row justify-center items-center shadow-lg w-2/3 border rounded-md ">
                <img
                  className="rounded-md"
                  loading="lazy"
                  src="./img/john-mayer.png"
                  alt=""
                />
                <div className="review p-4 lg:px-11">
                  <p className="font-poppins text-sm lg:text-xl">
                    <span className="text-xl lg:text-2xl">"</span>The Work
                    Progress Is So
                    <span className="font-bold text-xl lg:text-2xl">
                      {" "}
                      Fast
                    </span>{" "}
                    With
                    <span className="font-bold text-xl lg:text-2xl">
                      {" "}
                      Satisfyingly Result
                    </span>
                    . We Will Keep The Company To Be Our Vendor In The Future
                    <span className="text-xl">"</span>
                  </p>
                  <p className="font-bold text-right">John Mayer</p>
                  <p className="text-right">Director Of PT. Bumi Indah</p>
                  <button className="text-white float-right bg-main-color mt-5 p-3 pl-11 pr-11 mb-6 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                    <a href="#">Read Case Study</a>
                  </button>
                </div>
              </div>
            </div>
          </SplideSlide>
          <SplideSlide>
            <div className="flex justify-center lg:mt-20">
              <div className="card flex flex-col lg:flex-row justify-center items-center shadow-lg w-2/3 border rounded-md ">
                <img
                  className="rounded-md"
                  loading="lazy"
                  src="./img/john-mayer.png"
                  alt=""
                />
                <div className="review p-4 lg:px-11">
                  <p className="font-poppins text-sm lg:text-xl">
                    <span className="text-xl lg:text-2xl">"</span>The Work
                    Progress Is So
                    <span className="font-bold text-xl lg:text-2xl">
                      {" "}
                      Fast
                    </span>{" "}
                    With
                    <span className="font-bold text-xl lg:text-2xl">
                      {" "}
                      Satisfyingly Result
                    </span>
                    . We Will Keep The Company To Be Our Vendor In The Future
                    <span className="text-xl">"</span>
                  </p>
                  <p className="font-bold text-right">John Mayer</p>
                  <p className="text-right">Director Of PT. Bumi Indah</p>
                  <button className="text-white float-right bg-main-color mt-5 p-3 pl-11 pr-11 mb-6 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                    <a href="#">Read Case Study</a>
                  </button>
                </div>
              </div>
            </div>
          </SplideSlide>
        </Splide>
      </section>
    );
  }
}

export default Testimoni;
